export default __webpack_public_path__ + "static/media/DatePicker.e806ce64.svg";